export default __webpack_public_path__ + "static/media/vhs-tape.fac9bfc7.jpg";